export type MissingComponentProps = {
  rendering?: {
    componentName?: string;
  };
  errorOverride?: string;
};

const MissingComponent = (props: MissingComponentProps) => {
  const devMode = process.env.NODE_ENV === "development";
  if (devMode) {
    console.warn(
      `MissingComponent rendered - "${props?.rendering?.componentName}" was not found in the component factory. Please check the component factory configuration and ensure all components are correctly registered.`,
      props.errorOverride ? `Error: ${props.errorOverride}` : "",
    );
  }
  return <></>;
};

export default MissingComponent;
